import { ctaLoadingClass } from "./utils";

export const manageNotifyWhenAvailable = () => {
  const formSelector = "#notify-when-available-form";
  const modalSelector = "#catifa-notify-when-available";

  const form = document.querySelector<HTMLFormElement>(formSelector);

  if (!form) {
    return;
  }

  // we're relying on the form not being submitted if not valid
  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    const formData = new FormData(form);

    const submitButton = form.querySelector<HTMLButtonElement>("[type=submit]");

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add(ctaLoadingClass);
    }

    const formPayload: { [key in string]: string | File } = {};
    formData.forEach((value, key) => (formPayload[key] = value));

    window.dataLayer = window.dataLayer || [];

    const res = await fetch("/apps/catifa-api/app/api", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        command: "create_product_subscriber",
        payload: {
          ...formPayload,
          terms_and_conditions_acceptance: true,
          country:
            document.querySelector<HTMLSelectElement>("#locale_code")!.value,
        },
      }),
    });

    if (submitButton) {
      submitButton.disabled = false;
      submitButton.classList.remove(ctaLoadingClass);
    }

    if (!res.ok) {
      return res
        .json()
        .then((errorData) => {
          const errorMessage =
            errorData.message ||
            res.statusText ||
            "Failed to submit book now form";
          if (window.dataLayer !== undefined) {
            window.dataLayer.push({
              event: "form_error",
              type: "book_now",
              message: errorMessage,
            });
          }
          throw new Error(errorMessage);
        })
        .finally(() => {
          document
            .querySelector(modalSelector)
            ?.querySelector(".catifa-form-error-message")
            ?.classList.remove("hidden");
          return;
        });
    }

    if (window.dataLayer !== undefined) {
      window.dataLayer.push({
        event: "book_now",
        email: formPayload.email ?? "email_missing",
        item_id: formPayload.sku ?? "sku_missing",
        quantity: formPayload.quantity ?? "quantity_missing",
        phone_number: formPayload.phone_number ?? "phone_number_missing",
        marketing_consent: "true", // requested by the tracking company to pass it as a string
      });
    }

    form.reset();

    // try avoiding double submission
    form.remove();
    document
      .querySelector<HTMLButtonElement>("#notify-when-available")
      ?.remove();

    document
      .querySelector(modalSelector)
      ?.querySelector(".catifa-form-success-message")
      ?.classList.remove("hidden");
  });
};
